import React from "react";
import I18n from "i18n-js";

import { getCellColor } from "../services/flag";

const Flag = ({ flag }) => (
  <div className="flag">
    {flag ? (
      <table>
        <tbody>
          <tr>
            <td style={{ backgroundColor: getCellColor(flag.flagm) }}></td>
            <td style={{ backgroundColor: getCellColor(flag.flagt) }}></td>
            <td style={{ backgroundColor: getCellColor(flag.flag)  }}></td>
          </tr>
        </tbody>
      </table>
    ) : null}
    <span className="title" title={I18n.t("insights.stats.flag.title")}>
      {I18n.t("insights.stats.flag.title")}
    </span>
  </div>
);

export default Flag;
